  <div *ngIf="isConsentFormModal" class="modal fade" tabindex="-1" role="dialog"
    [config]="{ show: true, backdrop: consentProgress ? 'static' : 'relative' }" (onHidden)="onHidden()" bsModal
    #autoShownModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header px-3 py-2 text-right d-block" *ngIf="consentAgreeForm">
          <div class="row">
            <div class="col-8"></div>
            <div class="col-4">
              <span class="modal-close" (click)="hideModal()">&#215;</span>
            </div>
          </div>
        </div>
        <div *ngIf="consentAgreeForm" class="modal-body">
          <img class="mb-3" src="assets/images/grandround/docquity-clinic.svg" alt="Docquity clinic branding" height="32"/>
          <h4 class="heading-4 mb-2">{{mls.languageText.teleConsulting.key4}}</h4>
          <p class="secondary-paragraph">{{mls.languageText.teleConsulting.key5}}</p>
          <h4 class="heading-4 mt-4 mb-2">{{mls.languageText.teleConsulting.key6}}</h4>
          <ul>
            <li class="mb-3">
              <span>
                <img src="assets/images/grandround/e-prescription.svg" alt="prescription icon" />
              </span>
              {{mls.languageText.teleConsulting.key7}}
            </li>
            <li class="mb-3">
              <span>
                <img src="assets/images/grandround/tele-consultation.svg" alt="consultation icon" />
              </span>
              {{mls.languageText.teleConsulting.key8}}
            </li>
            <li class="mb-3">
              <span>
                <img src="assets/images/grandround/patient-communities.svg" alt="communities icon" />
              </span>
              {{mls.languageText.teleConsulting.key9}}
            </li>
          </ul>
          <label class="checkbox mt-4">
            <input type="checkbox" name="agree" id="consent-agree" [(ngModel)]="consentAgreed" />
            <span for="consent-agree">{{mls.languageText.teleConsulting.key10}}</span>
          </label>
          <div class="text-right mt-4">
            <button [disabled]="!consentAgreed" class="btn-design medium"
              [ngClass]="{'no-pointer-event filled-disabled' : !consentAgreed, 'filled': consentAgreed }" (click)="consentAgree()">
              {{mls.languageText.teleConsulting.key11}}
            </button>
          </div>
        </div>
        <div *ngIf="consentProgress" class="modal-body text-center pb-5 consent-form-progress relative">
          <img class="mb-5" src="assets/images/grandround/docquity-clinic.svg"
            alt="Docquity clinic branding" />
          <div class="relative">
            <img class="info-transfer" src="assets/images/grandround/consent-transfer.svg" alt="Transfer Consent" />
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <h4 class="heading-4 mt-5">{{mls.languageText.teleConsulting.key12}}</h4>
          <p class="secondary-paragraph">{{mls.languageText.teleConsulting.key13}}</p>
        </div>
        <div *ngIf="consentFailed" class="modal-body consent-form-progress relative">
          <span class="modal-close" (click)="hideModal()">
            <img src="assets/themes/icons/cancel.svg" alt="back">
          </span>
          <img class="mb-5" src="assets/images/grandround/docquity-clinic.svg"
            alt="Docquity clinic branding" />
          <div class="relative">
            <img class="info-transfer" src="assets/images/grandround/consent-transfer.svg" alt="Transfer Consent" />
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <h4 class="heading-4 mt-5">
            {{
            consentLoadAcknowledgement ?
            mls.languageText.teleConsulting.key12 :
            mls.languageText.teleConsulting.key17
            }}
          </h4>
          <p class="secondary-paragraph">
            {{
            consentLoadAcknowledgement ?
            mls.languageText.teleConsulting.key20 :
            mls.languageText.teleConsulting.key18
            }}
          </p>
        </div>
        <div *ngIf="consentSuccess" class="modal-body consent-form-progress">
          <img class="mb-5" src="assets/images/grandround/docquity-clinic.svg"
            alt="Docquity clinic branding" />
          <div>
            <img src="assets/images/grandround/success-tick.svg" alt="Progress" />
          </div>
          <h4 class="heading-4 mt-5">{{mls.languageText.teleConsulting.key15}}</h4>
          <p class="secondary-paragraph">{{mls.languageText.teleConsulting.key16}}</p>
        </div>
      </div>
    </div>
  </div>